<template>

  <thead class="hit-html-thead">
    <tr class="hit-html-tr">

      <th class="hit-html-th" v-for="(head, index) in titles ">
        <i class="hit-glyphicon" v-bind:class="get_icon(index)" /> <span v-html="head"></span>
      </th>

    </tr>
  </thead>

</template>

<script>

export default{

  props: {titles: Array, icons: Array},

  methods: {

    get_icon: function (index) {
      if (typeof this.icons[index] === 'undefined' || !this.icons[index]) { return false }

      var r = {}
      r['hit-glyphicon-' + this.icons[index]] = true

      return r
    }
  }

}

</script>
